$(document).ready(function () {
  $(document).mouseup(function (e) {
    var container = $(".account-menu-modal");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.removeClass("account-menu-modal-active");
      $("body").removeClass("accountslideout");
    }
  });

  var swiperModels = new Swiper(".models", {
    grabCursor: true,
    a11y: false,
    freeMode: true,
    speed: 2000,
    loop: true,
    slidesPerView: "auto",
    autoplay: {
      delay: 0.5,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.9,
        spaceBetween: 16,
      },
      480: {
        slidesPerView: 2.5,
        spaceBetween: 16,
      },
      600: {
        slidesPerView: 2.5,
        spaceBetween: 16,
      },
      800: {
        slidesPerView: 3.9,
        spaceBetween: 16,
      },
      1024: {
        slidesPerView: 5.1,
        spaceBetween: 8,
      },
      1400: {
        spaceBetween: 8,
        slidesPerView: 6.1,
      },
    },
  });

  $(".models").hover(
    function () {
      this.swiper.autoplay.stop();
    },
    function () {
      this.swiper.autoplay.start();
    }
  );

  //video embed
  const video = document.getElementById("video");
  const circlePlayButton = document.getElementById("circle-play-b");

  video.removeAttribute("controls");

  video.addEventListener("play", function () {
    video.setAttribute("controls", "controls");
  });

  video.addEventListener("ended", function () {
    video.removeAttribute("controls");
  });

  function togglePlay() {
    if (video.paused || video.ended) {
      video.play();
    } else {
      video.pause();
    }
  }
  circlePlayButton.addEventListener("click", togglePlay);
  video.addEventListener("playing", function () {
    circlePlayButton.style.opacity = 0;
  });
  video.addEventListener("pause", function () {
    circlePlayButton.style.opacity = 1;
  });

});


